import type React from 'react';

import { usePetitionDetailsPageData, usePetitionDetailsPageUserData } from '#src/app/pages/petitionDetails/pageContext';

import { useUnauthenticatedSignForm } from '../../hooks/signForm/useUnauthenticatedSignForm';
import { RespondContainerSunrise } from '../RespondSunrise';

import { SideClosedContainer } from './SideClosed';
import { SideSignedContainer } from './SideSigned';
import { SideUnsignedContainer } from './SideUnsigned';
import { SideVictoryContainer } from './SideVictory';

const SideContainerInner: React.FC = () => {
	const {
		data: {
			petition: { status },
		},
	} = usePetitionDetailsPageData();
	const {
		data: { decisionMaker, signed },
	} = usePetitionDetailsPageUserData();
	const {
		data: { enabled: unauthenticatedSignFormEnabled },
	} = useUnauthenticatedSignForm();

	if (decisionMaker) {
		return <RespondContainerSunrise />;
	}
	if (status === 'CLOSED') {
		return <SideClosedContainer />;
	}
	if (status === 'VICTORY') {
		return <SideVictoryContainer />;
	}
	if (signed && !unauthenticatedSignFormEnabled) {
		return <SideSignedContainer />;
	}
	return <SideUnsignedContainer />;
};

type Props = {
	containerRef?: React.RefObject<HTMLDivElement | null>;
};

export const SideContainer: React.FC<Props> = ({ containerRef }) => {
	return (
		<div ref={containerRef} className="rounded-large elevation-floating bg-white p-8">
			<SideContainerInner />
		</div>
	);
};
